import { Controller } from "@hotwired/stimulus"
import { SUBDOCUMENT_TYPES } from "../data/subdocument_types"

// Connects to data-controller="document-select"
export default class extends Controller {
  static targets = ["input", "tipoSelect", "subtipoSelect", "dropzoneArea"]
  static requiredTargets = ["input", "tipoSelect", "subtipoSelect"]

  connect() {
    this.dropzoneController = this.application.getControllerForElementAndIdentifier(
      this.dropzoneAreaTarget,
      'dropzone'
    );

    requestAnimationFrame(() => this.checkInputs());
  }

  updateSubtipo(event) {
    const selectedType = this.tipoSelectTarget.value;
    const subtipoSelect = this.subtipoSelectTarget;

    subtipoSelect.innerHTML = '<option value="">Seleccione el sub tipo de documentación</option>';

    if (selectedType && SUBDOCUMENT_TYPES[selectedType]) {
      const options = SUBDOCUMENT_TYPES[selectedType];
      options.forEach(option => {
        const newOption = document.createElement('option');
        newOption.value = option.value;
        newOption.textContent = option.label;
        subtipoSelect.appendChild(newOption);
      });
      subtipoSelect.disabled = false;
    } else {
      subtipoSelect.disabled = true;
    }
  }

  checkInputs(event) {
    if (!this.dropzoneController) {
      this.dropzoneController = this.application.getControllerForElementAndIdentifier(
        this.dropzoneAreaTarget,
        'dropzone'
      );
      if (!this.dropzoneController) return;
    }

    const fecha = this.element.querySelector('#archivo_fecha').value;
    const hora = this.element.querySelector('#archivo_hora').value;
    const tipo = this.tipoSelectTarget.value;
    const subtipo = this.subtipoSelectTarget.value;

    const allFilled = fecha && hora && tipo && subtipo;

    if (allFilled) {
      this.dropzoneController.enable();
      this.dropzoneAreaTarget.querySelector('.dropzone-msg-desc').textContent = 'Arrastre y suelte aquí los archivos que desea subir.';
    } else {
      this.dropzoneController.disable();
      this.dropzoneAreaTarget.querySelector('.dropzone-msg-desc').textContent = 'Debe completar fecha, hora, tipo y subtipo de documento para habilitar la carga.';
    }
  }

  disconnect() {
    this.dropzoneController = null;
  }
}
